export const showToast = options =>
  $(document).Toasts('create', {
    autohide: true,
    autoremove: true,
    body: null,
    class: 'm-2',
    close: true,
    delay: 5000,
    fade: true,
    fixed: true,
    icon: null,
    position: 'bottomRight',
    title: null,
    ...options,
  });

export const showInfoToast = options =>
  showToast({
    class: 'bg-info m-2',
    icon: 'fas fa-info-circle',
    title: 'Info',
    ...options,
  });

export const showSuccessToast = options =>
  showToast({
    class: 'bg-success m-2',
    icon: 'fas fa-check-square',
    title: 'Success',
    ...options,
  });

export const showWarningToast = options =>
  showToast({
    class: 'bg-warning m-2',
    icon: 'fas fa-exclamation-triangle',
    title: 'Warning',
    ...options,
  });
